import { ApplicationTypes, attachComponent } from 'awr-domain'

import {
  memoEval,
  sceneEntityObjectPropertiesComponent,
  sceneEntityObjectRemoteMaterialOverrideComponent,
  sceneEntityRemoteObjectComponent,
} from '@salsita-ai/platform-project-sdk/domain'

export const projectedEntityComponents = [
  attachComponent
    .withAlias('ProjectedEntity')
    .withComponent(sceneEntityRemoteObjectComponent, 'partObjects')
    .withGradualFilter({ viewStates: [ApplicationTypes.ViewState['3dView']] })
    .attachMany(
      memoEval(
        s => [s.$partObjects],
        partObjects => {
          return partObjects.map(p => {
            return {
              key: p.key,
              fileUrl: p.fileUrl,
              objectName: p.objectName,
              dimensionUnit: 'mm',
            }
          })
        }
      )
    ),
  attachComponent
    .withAlias('ProjectedEntity')
    .withComponent(sceneEntityObjectPropertiesComponent, 'partObjects')
    .withGradualFilter({ viewStates: [ApplicationTypes.ViewState['3dView']] })
    .attachMany(
      memoEval(
        s => [s.$partObjects],
        partObjects => {
          return partObjects.map(p => {
            return {
              key: p.key,
              offsetX: p.x,
              offsetY: p.y,
              offsetZ: p.z,
              rotationX: p.rotationX,
              rotationY: p.rotationY,
              rotationZ: p.rotationZ,
              scaleX: p.scaleX,
              scaleY: p.scaleY,
              scaleZ: p.scaleZ,
              morphTargetInfluences: p.morphTargetInfluences,
            }
          })
        }
      )
    ),
  attachComponent
    .withAlias('ProjectedEntity')
    .withComponent(sceneEntityObjectRemoteMaterialOverrideComponent, 'partObjects')
    .withGradualFilter({ viewStates: [ApplicationTypes.ViewState['3dView']] })
    .attachMany(
      memoEval(
        s => [s.$partObjects],
        partObjects => {
          return partObjects.map(p => {
            return {
              key: p.key,
              fileUrl: '/models/materials.glb',
              materialName: p.material,
              metalness: p.metalness,
              materialsToOverride: ['postFinish', 'intermediatePostFinish', 'wood', 'finish', 'wireFinish', 'plastic'],
            }
          })
        }
      )
    ),
  attachComponent
    .withAlias('ProjectedEntity')
    .withComponent(sceneEntityRemoteObjectComponent, 'floorPlanParts')
    .withGradualFilter({
      viewStates: [ApplicationTypes.ViewState.FloorPlan],
      navigationStates: [ApplicationTypes.NavigationState.Properties, ApplicationTypes.NavigationState.Summary],
    })
    .attachMany(
      memoEval(
        s => [s.$partObjects],
        partObjects => {
          return partObjects.map(p => {
            return {
              key: p.key,
              fileUrl: p.fileUrl,
              objectName: p.objectName,
              dimensionUnit: 'mm',
            }
          })
        }
      )
    ),
  attachComponent
    .withAlias('ProjectedEntity')
    .withComponent(sceneEntityObjectPropertiesComponent, 'floorPlanParts')
    .withGradualFilter({
      viewStates: [ApplicationTypes.ViewState.FloorPlan],
      navigationStates: [ApplicationTypes.NavigationState.Properties, ApplicationTypes.NavigationState.Summary],
    })
    .attachMany(
      memoEval(
        s => [s.$partObjects],
        partObjects => {
          return partObjects.map(p => {
            return {
              key: p.key,
              offsetX: p.x,
              offsetY: p.y,
              offsetZ: p.z,
              rotationX: p.rotationX,
              rotationY: p.rotationY,
              rotationZ: p.rotationZ,
              scaleX: p.scaleX,
              scaleY: p.scaleY,
              scaleZ: p.scaleZ,
              morphTargetInfluences: p.morphTargetInfluences,
            }
          })
        }
      )
    ),
  attachComponent
    .withAlias('ProjectedEntity')
    .withComponent(sceneEntityObjectRemoteMaterialOverrideComponent, 'floorPlanParts')
    .withGradualFilter({
      viewStates: [ApplicationTypes.ViewState.FloorPlan],
      navigationStates: [ApplicationTypes.NavigationState.Properties, ApplicationTypes.NavigationState.Summary],
    })
    .attachMany(
      memoEval(
        s => [s.$partObjects],
        partObjects => {
          return partObjects.map(p => {
            return {
              key: p.key,
              fileUrl: '/models/materials.glb',
              materialName: p.material,
              materialsToOverride: ['postFinish', 'intermediatePostFinish', 'wood', 'finish', 'wireFinish', 'plastic'],
            }
          })
        }
      )
    ),
]
